export default __webpack_public_path__ + "files/apple_search_ads.png";